import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { useExperience, ALT, isWebsite } from '@/store/experience';

// Camera rig: altitude comes from the cinematic timeline (intro) or scroll (website).
export function CameraRig() {
  const frame = useExperience((s) => s.frame);
  const reduced = useExperience((s) => s.reducedMotion);
  const lastY = useRef(ALT.PLANE);
  const smooth = useRef({ y: ALT.PLANE, pitch: -1.25, px: 0, py: 0 });

  useFrame(({ camera }, dt) => {
    const phase = useExperience.getState().phase;
    const s = smooth.current;
    const k = Math.min(1, dt * 4);
    const targetY = isWebsite(phase) ? ALT.HERO - frame.scroll * ALT.DESCENT : frame.altitude;
    s.y += (targetY - s.y) * (isWebsite(phase) ? Math.min(1, dt * 5) : 1);
    s.pitch += (frame.pitch - s.pitch) * k;
    const par = reduced ? 0 : 1;
    s.px += (frame.pointer.x * par - s.px) * k;
    s.py += (frame.pointer.y * par - s.py) * k;

    const t = performance.now() * 0.001;
    camera.rotation.order = 'YXZ';
    camera.position.set(s.px * 0.6 + Math.sin(t * 0.3) * 0.15 * par, s.y + Math.sin(t * 0.45) * 0.12 * par, 0);
    camera.rotation.x = s.pitch + s.py * 0.05 + Math.sin(t * 0.37) * 0.006 * par;
    camera.rotation.y = -s.px * 0.06 + Math.sin(t * 0.21) * 0.008 * par;
    camera.rotation.z = frame.roll + Math.sin(t * 0.5) * 0.004 * par;
    if (Math.abs(camera.fov - frame.fov) > 0.05) { camera.fov += (frame.fov - camera.fov) * k; camera.updateProjectionMatrix(); }

    frame.velocity = dt > 0 ? (lastY.current - s.y) / dt : 0;
    lastY.current = s.y;
  });
  return null;
}
